export class StockInPritnRequest{
    reportingLogId: number;
  
    constructor(  reportingLogId: number){
        this.reportingLogId=reportingLogId;
    
}
}